<template>
  <div>
    <b-spinner v-if="isLoading"></b-spinner>
  </div>
</template>

<script>
import * as UserApi from '../api/user'

export default {
  data() {
    return {
      relayState: '',
      isLoading: false
    }
  },
  methods: {
    async callKauLogin(relayState) {
      try {
        await UserApi.kauLogin({
          email: ' ',
          password: ' ',
          relayState: relayState
        })
        await this.$store.dispatch('getMe')
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created() {
    this.isLoading = true
    this.relayState = this.$route.query.relayState
    try {
      this.callKauLogin(this.relayState)

      setTimeout(() => {
        this.$router.push('/home')
      }, 1000)
      return (this.isLoading = false)
    } catch (error) {
      console.log(error)
      return this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped></style>
